import { useEffect } from "react";
import {
  Container,
  MessageBody,
  MessageContainer,
  MessageIcon,
  MessageTitle,
} from "./styles";

import { useDispatch } from "react-redux";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";

import { fetchTaskChat } from "../../../../state/chat/actions";
import { useSelector } from "react-redux";
import ReactLoading from "react-loading";

import { getChatLog } from "../../../../state/chat/selector";
import { DateTime } from "luxon";

const reformatMentions = (str) => {
  return str
    .replace(/@\[([^\]]+)\]\([^)]+\)/g, '<span class="mention">@$1</span>')
    .replace(/#\[([^\]]+)\]\([^)]+\)/g, '<span class="subtask">#$1</span>');
};

function MessageWithMentions({ message }) {
  const msg = reformatMentions(message);

  return <p dangerouslySetInnerHTML={{ __html: msg }} />;
}

const ChatComponent = ({ isEmpty, chat = [], user, date, ref }) =>
  !isEmpty ? (
    [...chat].reverse().map((item) => (
      <Container position={user._id !== item.userId} key={item._id}>
        <MessageIcon src={item.avatarURL} />
        <MessageContainer>
          <MessageTitle position={user._id !== item.userId}>
            {item.username}, {date(item.createdAt)}
          </MessageTitle>
          <MessageBody>
            <MessageWithMentions message={item.message} />
          </MessageBody>
        </MessageContainer>
      </Container>
    ))
  ) : (
    <>
      <p style={{ color: "#a9aeb4", fontSize: "1rem", marginTop: "1rem" }}>
        Ainda não há comentários
      </p>
    </>
  );

const MessageRender = ({ task, user }) => {
  const chat = useSelector((state) => getChatLog(state, task._id));

  const isChatEmpty = chat.length === 0;

  const { promiseInProgress } = usePromiseTracker({ area: "fetching-chat" });

  const dispatch = useDispatch();

  const dateFormat = (msg) => {
    return DateTime.fromISO(msg)
      .setLocale("pt-br")
      .toFormat("HH:mm - dd MMM yyyy");
  };

  async function getMessages(refId) {
    await trackPromise(
      dispatch(fetchTaskChat({ refId })).catch((err) => console.log(err)),
      "fetching-chat"
    );
  }

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      getMessages(task._id);
    }
    return () => (isMounted = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return !promiseInProgress ? (
    <ChatComponent
      isEmpty={isChatEmpty}
      chat={chat}
      user={user}
      date={dateFormat}
    />
  ) : (
    <ReactLoading type="bars" color="#118052" width={50} height={32} />
  );
};

export default MessageRender;
